// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1KJzD","roll":"style_roll__sqQEE","colors":"style_colors__2KIlm","i1":"style_i1__2If9P","i2":"style_i2__2-86F","i3":"style_i3__j7k3c"};